import React from 'react';
import EditableBranchTemplate from '../components/EditableBranchTemplate';
import { technologyData } from '../data/technologyData';

const Technology = () => {
  const handleSave = (updatedContent) => {
    console.log('Saving updated content:', updatedContent);
    alert('Content saved successfully! (Check console for details)');
  };

  return (
    <EditableBranchTemplate
      title="Web3 Technology"
      sections={technologyData}
      onSave={handleSave}
    />
  );
};

export default Technology;